import { render, staticRenderFns } from "./referralsLayout.vue?vue&type=template&id=65debe8d&scoped=true"
import script from "./referralsLayout.vue?vue&type=script&lang=js"
export * from "./referralsLayout.vue?vue&type=script&lang=js"
import style0 from "./referralsLayout.vue?vue&type=style&index=0&id=65debe8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65debe8d",
  null
  
)

export default component.exports